import { type ActionCreator, on, type ReducerTypes } from '@ngrx/store';

import { type EngineStateBase, runtimeActions } from '@blaze-runtime/engine-data-access';

import { runtimeError } from './runtime-errors.actions';

export const runtimeErrorsReducerTypes: ReducerTypes<EngineStateBase, ActionCreator[]>[] = [
  on(runtimeError, (state, runtimeError) => {
    const runtimeErrors = { ...state.runtimeErrors };
    runtimeErrors[runtimeError.workflowId] = { ...runtimeError };
    return { ...state, runtimeErrors };
  }),

  on(runtimeActions.applyWorkflow, (state, { workflow }) => {
    const wfId = workflow?.id;
    if (wfId && state.runtimeErrors[wfId]) {
      const runtimeErrors = { ...state.runtimeErrors };
      delete runtimeErrors[wfId];
      return { ...state, runtimeErrors };
    }

    return state;
  }),
];
